import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import {
  backendShape,
  browserShape,
  isEmpty,
  Container,
  withBrowser,
  withBackend,
  removeApiAttributes,
} from "lcm-iot-commons";
import PasswordResetForm from "./PasswordResetForm";
import PasswordResetSuccess from "./PasswordResetSuccess";
import PasswordResetError from "./PasswordResetError";

type Props = {
  backend: backendShape;
  location: {
    search?: string;
  };
  browser: browserShape;
};

export function PasswordReset({ backend, location, browser }: Props) {
  const [isPasswordResetPage, setIsPasswordResetPage] = useState("MainPage");
  const [shouldRender, setShouldRender] = useState(true);
  const [redirectUri, setRedirectUri] = useState(undefined);

  const queryParameter = (loc: $TSFixMe, param: $TSFixMe) =>
    loc && loc.search ? new URLSearchParams(loc.search).get(param) : undefined;

  React.useEffect(() => {
    if (isEmpty(queryParameter(location, "reset_password_token"))) {
      setShouldRender(false);
      browser.navigateTo("");
    }
  }, [location]);

  const handleOnSubmit = async (values: $TSFixMe, actions: $TSFixMe) => {
    try {
      const updateObject = {
        reset_password_token: queryParameter(location, "reset_password_token"),
        password: values.password,
      };
      await backend.patch("/users/reset_password", updateObject);
      // @ts-expect-error TS(2345) FIXME: Argument of type 'string | null | undefined' is no... Remove this comment to see the full error message
      setRedirectUri(queryParameter(location, "redirect_uri"));
      setIsPasswordResetPage("SuccessPage");
    } catch (error) {
      removeApiAttributes(error, "reset_password_token");
      setIsPasswordResetPage("ErrorPage");
      actions.setSubmitting(false);
    }
  };

  return (
    <Container>
      {shouldRender && isPasswordResetPage === "MainPage" ? (
        // @ts-expect-error TS(2322) FIXME: Type '{ onSubmit: (values: any, actions: any) => P... Remove this comment to see the full error message
        <PasswordResetForm onSubmit={handleOnSubmit} />
      ) : null}
      {shouldRender && isPasswordResetPage === "SuccessPage" ? (
        <PasswordResetSuccess redirectUri={redirectUri} />
      ) : null}
      {shouldRender && isPasswordResetPage === "ErrorPage" ? (
        <PasswordResetError />
      ) : null}
    </Container>
  );
}

export default withRouter(withBrowser(withBackend(PasswordReset)));
